exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.bucket-card[data-v-b1a4e416] {\n  margin-bottom: 1em;\n}\n.bucket-last-updated[data-v-b1a4e416] {\n  color: #666;\n}\n", ""]);

// exports
